import { useEffect, useState } from "react";
import RatingSummary from "./RatingSummary";
import CommentCard from "./CommentCard";
import { useAuth } from "../../../context/AuthContext";
import ReviewForm from "./ReviewForm";
import EditReviewForm from "./EditReviewForm";
import LoginToReview from "./LoginToReview";
import { ChevronDown } from "lucide-react";

export default function ProductComments({
    comments = [],
    myComment,
    myRate,
    rating,
    id
}) {

    const [visibleCount, setVisibleCount] = useState(2);
    const showMore = () => {setVisibleCount((prev) => prev + 2); };
    const visibleComments = comments.slice(0, visibleCount);
    const { user } = useAuth();

    return (
        <>
            <div className="product-comments">

                <div className={comments.length === 0 ? "comments-right-none" : "comments-right"} >
                    {/* <div className="comments-right"> */}
                    <RatingSummary rating={rating} />

                    <div className="comments-list">

                        {comments.length === 0 ?

                            <div className="empty-comments">
                                اولین نفری باشید که برای این محصول نظر می دهید.
                            </div>
                            :
                            visibleComments.map(comment => (
                                <CommentCard
                                    key={comment.id}
                                    comment={comment}
                                />

                            ))

                        }

                    </div>


                    <div className="wrapper-footer">
                        {comments.length > visibleCount && (
                            <button onClick={showMore} className="show-more-btn">
                                نمایش بیشتر
                                <ChevronDown color="#95b73c" />
                            </button>
                        )}
                    </div>
                </div>

                {user ? (

                    myComment ? (
                        <EditReviewForm comment={myComment} rate={myRate} />
                    ) : (
                        <ReviewForm id={id} type="products" />
                    )

                ) : (

                    <LoginToReview user={user} comments={comments.length} />

                )}


            </div>
        </>

    )

}